import styled from 'styled-components';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  gap: 28px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
  }
`;

export default Layout;
